'use strict';

exports.__esModule = true;
exports.backendUrl = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.status = status;
exports.extractApiError = extractApiError;

var _accessTokenStorage = require('../lib/accessTokenStorage');

var _accessTokenStorage2 = _interopRequireDefault(_accessTokenStorage);

var _languages = require('../lib/languages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var backendUrl = exports.backendUrl = process.env.REACT_APP_BACKEND_URL;

function status(response) {
  if (response.ok) {
    return response;
  }
  if (response.status === 401) {
    _accessTokenStorage2.default.remove();
    if (!window.location.pathname.includes('/login')) {
      window.location.assign('/login');
    }
  }
  var contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return response.json()
    // eslint-disable-next-line prefer-promise-reject-errors
    .then(function (body) {
      return Promise.reject(_extends({}, body, { status: response.status }));
    });
  }
  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({ message: response.statusText });
}

// Kontrollschluessel, die im ALT-flachen Reject-Shape KEINE DRF-Feldfehler sind, sondern
// Metadaten. Alles Uebrige auf Top-Level wird als potenzieller DRF-Feldfehler behandelt.
var NON_FIELD_META_KEYS = ['status', 'http_status', 'detail', 'message', 'code', 'trace_id', 'error'];

// Wert -> String-Message normalisieren. Arrays werden gejoint, Objekte werden NIE als
// message durchgereicht (stattdessen leer -> Fallback greift). Verhindert [object Object].
function toMessage(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    return value.filter(function (v) {
      return typeof v === 'string' || typeof v === 'number';
    }).join(' ');
  }
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return '';
}

// Einen DRF-Feldfehler-Wert IMMER als String-Array normalisieren.
function toFieldMessages(value) {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.map(function (v) {
      return typeof v === 'string' ? v : toMessage(v);
    }).filter(Boolean);
  }
  var asString = toMessage(value);
  return asString ? [asString] : [];
}

/**
 * extractApiError — normalisiert JEDEN Reject-Value der API-Schicht in ein einheitliches
 * Fehler-Objekt { code, message, trace_id, fields, status }. Liest BEIDE Welten tolerant
 * (kritisch fuers Deploy-Fenster, da das Backend das neue Envelope-Schema spaeter deployt):
 *
 *  - NEU-Envelope: { error: { code, message, trace_id, fields }, http_status }
 *  - ALT-flach (heutiges status()-Reject '{ ...body, status }'):
 *      DRF-Feldfehler top-level { email: [..], non_field_errors: [..] } -> fields
 *      { detail } -> message ; { message: String|Array } -> message
 *  - roher String (upload/patchXHR-Altfall) -> { message: e }
 *  - { message: statusText } (Nicht-JSON) -> message
 *
 * Rueckgabe-Garantie: message ist IMMER ein String (nie ein Objekt), fields ist
 * { feld: [msg, ...] } oder null (Werte immer Arrays), status ist number|null.
 *
 * @param {*} e - der im .catch angekommene Reject-Value
 * @returns {{ code: (string|null), message: string, trace_id: (string|null), fields: (Object|null), status: (number|null) }}
 */
function extractApiError(e) {
  var empty = {
    code: null,
    message: '',
    trace_id: null,
    fields: null,
    status: null
  };

  if (e == null) {
    return empty;
  }

  // roher String (upload/patchXHR-Altfall bei Nicht-JSON) -> als message
  if (typeof e === 'string') {
    return _extends({}, empty, { message: e });
  }

  // primitive Nicht-Objekte defensiv
  if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) !== 'object') {
    return _extends({}, empty, { message: toMessage(e) });
  }

  var status = null;
  if (e.http_status != null) {
    status = e.http_status;
  } else if (e.status != null) {
    status = e.status;
  }

  // NEU-Envelope: { error: { code, message, trace_id, fields }, http_status }
  if (e.error && _typeof(e.error) === 'object' && !Array.isArray(e.error)) {
    var err = e.error;
    var _fields = null;
    if (err.fields && _typeof(err.fields) === 'object' && !Array.isArray(err.fields)) {
      Object.keys(err.fields).forEach(function (key) {
        // Symmetrisch zum ALT-Zweig: leer-gefilterte Feld-Arrays droppen. Sonst wuerde
        // { email: [null, {}] } -> { email: [] } durchrutschen, der Consumer (Form.jsx)
        // setzt formErrors.email='' (Nutzer sieht KEINEN Fehler) und der
        // request-failed-Fallback greift nicht, weil der Key existiert.
        var msgs = toFieldMessages(err.fields[key]);
        if (msgs.length > 0) {
          if (_fields === null) _fields = {};
          _fields[key] = msgs;
        }
      });
      // leeres fields (alle Felder leer-gefiltert) -> null, genau wie der ALT-Zweig.
    }
    return {
      code: err.code != null ? err.code : null,
      message: toMessage(err.message),
      trace_id: err.trace_id != null ? err.trace_id : null,
      fields: _fields,
      status: status
    };
  }

  // ALT-flach: DRF-Feldfehler top-level + detail/message
  var fields = null;
  Object.keys(e).forEach(function (key) {
    if (NON_FIELD_META_KEYS.indexOf(key) !== -1) return;
    var msgs = toFieldMessages(e[key]);
    if (msgs.length > 0) {
      if (fields === null) fields = {};
      fields[key] = msgs;
    }
  });

  // message-Prioritaet: explizites message -> detail -> non_field_errors (falls als Feld
  // erfasst) -> leer (Consumer faellt dann auf generische Meldung/status zurueck).
  var message = toMessage(e.message);
  if (!message) message = toMessage(e.detail);
  if (!message && fields && fields.non_field_errors) {
    message = fields.non_field_errors.join(' ');
  }

  return {
    code: e.code != null ? e.code : null,
    message: message,
    trace_id: e.trace_id != null ? e.trace_id : null,
    fields: fields,
    status: status
  };
}

function json(response) {
  if (response.status !== 204) {
    var contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return response.json();
    }
    return response;
  }
}

var ServerApi = function () {
  function ServerApi() {
    _classCallCheck(this, ServerApi);

    this.opts = function (bodyExist) {
      return {
        headers: _extends({}, _accessTokenStorage2.default.isExist() ? { Authorization: 'Token ' + _accessTokenStorage2.default.get() } : {}, {
          'Content-Language': (0, _languages.getDefaultLanguage)(),
          Accept: 'application/json'
        }, bodyExist ? { 'Content-type': 'application/json' } : {})
      };
    };
    this.bodyConverter = function (body) {
      return JSON.stringify(body);
    };
  }

  ServerApi.prototype.buildUrl = function buildUrl(path) {
    var useV1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return '' + backendUrl + (useV1 ? '/v1' : '') + path;
  };

  /**
   * Make GET ajax request.
   * @param url - requested url
   * @param useV1
   * @param useRecruiting
   * @returns {Promise.<TResult>}
   */


  ServerApi.prototype.get = function get(url) {
    var useV1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return fetch(this.buildUrl(url, useV1), _extends({
      method: 'get'
    }, this.opts(false))).then(status).then(json);
  };

  ServerApi.prototype.post = function post(url, body) {
    var useV1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return fetch(this.buildUrl(url, useV1), _extends({
      method: 'post'
    }, this.opts(body), {
      body: this.bodyConverter(body)
    })).then(status).then(json);
  };

  ServerApi.prototype.postWithCustomUrl = function postWithCustomUrl(url, body) {
    return fetch(url, _extends({
      method: 'post'
    }, this.opts(body), {
      body: this.bodyConverter(body)
    })).then(status).then(json);
  };

  ServerApi.prototype.postFormData = function postFormData(url, body) {
    return fetch(url, {
      method: 'post',
      body: body
    }).then(status).then(json);
  };

  // postXHR: byte-identische Variante von post() (gleiche URL/Header/JSON-Body), nur
  // ueber XMLHttpRequest statt fetch — damit echtes Upload-%-Progress moeglich wird
  // (fetch kann kein upload.onprogress). Bewusst KEIN FormData/multipart (upload()):
  // das wuerde den Content-Type und das serverseitige Verhalten aendern. onProgress ist
  // optional. Response-Parsing spiegelt status()+json() (2xx -> JSON; 204 -> undefined;
  // >=300+JSON -> reject {...body, status}; sonst reject {message}).


  ServerApi.prototype.postXHR = function postXHR(url, body, onProgress) {
    var _this = this;

    var useV1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', _this.buildUrl(url, useV1), true);

      var _opts = _this.opts(body),
          headers = _opts.headers;

      Object.keys(headers).forEach(function (name) {
        return xhr.setRequestHeader(name, headers[name]);
      });
      if (onProgress) {
        xhr.upload.onprogress = function (e) {
          if (e.lengthComputable) {
            onProgress(Math.round(e.loaded / e.total * 100));
          }
        };
      }
      xhr.onload = function onLoad() {
        var contentType = this.getResponseHeader('content-type');
        var isJson = contentType && contentType.includes('application/json');
        var ok = this.status >= 200 && this.status < 300;
        // JSON.parse defensiv: bei Content-Type=json aber unparsebarem Body (leer/
        // truncated/falsch gelabelt) garantiert reject statt unhandled throw im onload
        // (sonst settled der Promise nie -> loading bleibt true -> Spinner haengt). Das
        // spiegelt fetch+json(), das bei kaputtem Body ein rejected Promise liefert.
        var parsed = void 0;
        if (isJson) {
          try {
            parsed = JSON.parse(this.responseText);
          } catch (e) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ message: this.statusText, status: this.status });
            return;
          }
        }
        if (ok) {
          if (this.status === 204) {
            resolve(undefined);
          } else if (isJson) {
            resolve(parsed);
          } else {
            // Abweichung von json() (das das Response-Objekt liefert): hier der rohe
            // Text. Fuer die JSON-Endpunkte (media) irrelevant; bewusst simpel gehalten.
            resolve(this.responseText);
          }
        } else if (isJson) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(_extends({}, parsed, { status: this.status }));
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({ message: this.statusText });
        }
      };
      xhr.onerror = function () {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ message: xhr.statusText });
      };
      xhr.send(_this.bodyConverter(body));
    });
  };

  ServerApi.prototype.upload = function upload(url, body, onProgress) {
    var _this2 = this;

    var useV1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var formData = new FormData();

    Object.keys(body).forEach(function (name) {
      // issue in firefox to pass 3 param undefined
      if (name === 'video') {
        formData.append(name, body[name], body[name].name);
      } else {
        formData.append(name, body[name]);
      }
    });

    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', _this2.buildUrl(url, useV1), true);

      var _opts2 = _this2.opts(false),
          headers = _opts2.headers;
      // eslint-disable-next-line guard-for-in


      for (var name in headers) {
        xhr.setRequestHeader(name, headers[name]);
      }
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          var percentComplete = e.loaded / e.total * 100;
          onProgress(Math.round(percentComplete));
        }
      };
      xhr.onload = function onLoad() {
        var contentType = this.getResponseHeader('content-type');
        var isJson = contentType && contentType.includes('application/json');
        if (isJson) {
          var parsed = void 0;
          try {
            parsed = JSON.parse(this.response);
          } catch (e) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ message: this.statusText, status: this.status, http_status: this.status });
            return;
          }
          if (this.status >= 300) {
            // status bleibt fuer Abwaertskompatibilitaet erhalten; http_status neu (Schema).
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(_extends({ status: this.status, http_status: this.status }, parsed));
          } else {
            resolve(parsed);
          }
        } else {
          // Nicht-JSON (z. B. 500 HTML/Text): frueher wurde der ROHE String rejectet ->
          // im .catch ein String statt Objekt. Jetzt in {message} kapseln, damit der
          // Reject-Value konsistent ein Objekt ist (extractApiError liest beides tolerant).
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({ message: this.response || this.statusText, status: this.status, http_status: this.status });
        }
      };
      xhr.onerror = function () {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ message: _this2.statusText, status: _this2.status, http_status: _this2.status });
      };
      xhr.send(formData);
    });
  };

  ServerApi.prototype.patch = function patch(url, body) {
    var useV1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return fetch(this.buildUrl(url, useV1), _extends({
      method: 'PATCH'
    }, this.opts(body), {
      body: this.bodyConverter(body)
    })).then(status).then(json);
  };

  ServerApi.prototype.patchXHR = function patchXHR(url, body, onProgress) {
    var _this3 = this;

    var useV1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('PATCH', _this3.buildUrl(url, useV1), true);

      var _opts3 = _this3.opts(true),
          headers = _opts3.headers;
      // eslint-disable-next-line guard-for-in


      for (var name in headers) {
        xhr.setRequestHeader(name, headers[name]);
      }
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          var percentComplete = e.loaded / e.total * 100;
          onProgress(Math.round(percentComplete));
        }
      };
      xhr.onload = function onLoad() {
        var contentType = this.getResponseHeader('content-type');
        var isJson = contentType && contentType.includes('application/json');
        var ok = this.status >= 200 && this.status < 300;
        // Bugfix: fruehere Version hatte KEIN return nach reject() -> bei 400/405 wurde
        // zusaetzlich resolve() erreicht, und 403/404/409/429 fielen ganz durch (weder
        // reject noch Guard) -> Fehler wurde als ERFOLG resolved und landete nie im
        // .catch. Jetzt: JSON.parse defensiv, ALLE Nicht-2xx (>=300) explizit rejecten,
        // nach jedem reject ein return, nur 2xx resolven. Reject-Shape traegt
        // http_status (neues Fehler-Schema); extractApiError liest es tolerant.
        var parsed = void 0;
        if (isJson) {
          try {
            parsed = JSON.parse(this.responseText);
          } catch (e) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ message: this.statusText, http_status: this.status });
            return;
          }
        }
        if (ok) {
          if (this.status === 204) {
            resolve(undefined);
          } else if (isJson) {
            resolve(parsed);
          } else {
            resolve(this.responseText);
          }
          return;
        }
        if (isJson) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(_extends({}, parsed, { http_status: this.status }));
          return;
        }
        // Nicht-JSON-Fehler (z. B. 500 HTML/Text): rohen Text in {message} kapseln,
        // damit der Reject-Value ein Objekt bleibt (kein roher String im .catch).
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ message: this.responseText || this.statusText, http_status: this.status });
      };
      xhr.onerror = function () {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ message: xhr.statusText, http_status: xhr.status });
      };
      xhr.send(_this3.bodyConverter(body));
    });
  };

  /**
   * Make PUT ajax request.
   * @param url - requested url
   * @param body - object {key: value}
   * @returns {Promise.<TResult>}
   */


  ServerApi.prototype.put = function put(url, body) {
    return fetch(this.buildUrl(url), _extends({
      method: 'put'
    }, this.opts(body), {
      body: this.bodyConverter(body)
    })).then(status).then(json);
  };

  /**
   * Make DELETE ajax request.
   * @param url - requested url
   * @param body - object {key: value}
   * @returns {Promise.<TResult>}
   */


  ServerApi.prototype.delete = function _delete(url, body) {
    return fetch(this.buildUrl(url), _extends({
      method: 'delete'
    }, this.opts(body), {
      body: this.bodyConverter(body)
    })).then(status).then(json);
  };

  return ServerApi;
}();

exports.default = ServerApi;